import React, {FunctionComponent} from 'react';
import './EntryImage.less';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

interface EntryImageProps {
	src: string,
	visibleByDefault?: boolean
}

export const EntryImage: FunctionComponent<EntryImageProps> = ({src, visibleByDefault}) => {
	return (
		<div className="entry-image">
			<LazyLoadImage className="entry-image__image" effect="opacity" src={src} visibleByDefault={visibleByDefault}/>
		</div>
	);
};
